import { useEffect, useState, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import { ClientSidebar } from "@/components/sidebars";
import { apiClient } from "@/lib/api";
import EvaluacionModal from "@/components/EvaluacionModal";

export default function Historial() {
  const [items, setItems] = useState([]);
  const [evaluaciones, setEvaluaciones] = useState([]);
  const [evaluar, setEvaluar] = useState(null); // solicitud object being evaluated
  const [searchParams, setSearchParams] = useSearchParams();

  const evaluadasSet = useMemo(
    () => new Set(evaluaciones.map((e) => e.solicitud_id)),
    [evaluaciones]
  );
  const evaluacionByServiceId = useMemo(() => {
    const map = {};
    evaluaciones.forEach((e) => { map[e.solicitud_id] = e; });
    return map;
  }, [evaluaciones]);

  const loadAll = () => {
    apiClient.get("/solicitudes").then(({ data }) => setItems(data)).catch(() => {});
    apiClient.get("/me/evaluaciones").then(({ data }) => setEvaluaciones(data)).catch(() => {});
  };

  useEffect(() => { loadAll(); }, []);

  // Auto-open eval modal when arriving from email link ?evaluar=<sid>
  useEffect(() => {
    const target = searchParams.get("evaluar");
    if (target && items.length > 0 && !evaluar) {
      const s = items.find((x) => x.id === target);
      if (s && s.status === "completada" && !evaluadasSet.has(s.id)) {
        setEvaluar(s);
      }
      // Clean the URL param whether we opened it or not, to avoid re-triggering
      searchParams.delete("evaluar");
      setSearchParams(searchParams, { replace: true });
    }
  }, [items, evaluadasSet, searchParams, setSearchParams, evaluar]);

  return (
    <AppLayout sidebar={ClientSidebar}>
      <header className="app-header"><h1>Historial de solicitudes</h1></header>
      <div className="panel">
        {items.length === 0 ? <p>Aún no hay solicitudes.</p> : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Fecha</th><th>Tipo</th><th>Beneficiario</th><th>Status</th>
                <th>Descripción</th><th>Evaluación</th>
              </tr>
            </thead>
            <tbody>
              {items.map((s) => {
                const evalDoc = evaluacionByServiceId[s.id];
                const isCompletado = s.status === "completada";
                return (
                  <tr key={s.id} data-testid={`hist-${s.id}`}>
                    <td>{new Date(s.created_at).toLocaleString("es-MX")}</td>
                    <td><strong>{s.tipo.toUpperCase()}</strong></td>
                    <td>{s.beneficiario?.nombre}</td>
                    <td><span className={`sol-pill sol-${s.status}`}>{s.status}</span></td>
                    <td>{s.descripcion}</td>
                    <td>
                      {!isCompletado && <span style={{ color: "#94a3b8", fontSize: 12 }}>—</span>}
                      {isCompletado && evalDoc && (
                        <span data-testid={`eval-done-${s.id}`} style={{ color: "#F59E0B", fontWeight: 700 }}>
                          {"★".repeat(Math.round(evalDoc.average_rating))}
                          {"☆".repeat(5 - Math.round(evalDoc.average_rating))}
                          <span style={{ color: "#6b7280", fontSize: 12, marginLeft: 6 }}>
                            {evalDoc.average_rating}/5
                          </span>
                        </span>
                      )}
                      {isCompletado && !evalDoc && (
                        <button
                          onClick={() => setEvaluar(s)}
                          data-testid={`eval-btn-${s.id}`}
                          style={{
                            background: "#163680", color: "white", border: "none",
                            padding: "6px 14px", borderRadius: 6, fontWeight: 600, cursor: "pointer", fontSize: 13,
                          }}
                        >
                          Evaluar
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {evaluar && (
        <EvaluacionModal
          solicitud={evaluar}
          onClose={() => setEvaluar(null)}
          onSubmitted={() => { loadAll(); }}
        />
      )}
    </AppLayout>
  );
}
